// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__TErPv","content":"style_content__22QsU","button":"style_button__DKGxr","title":"style_title__IFvK+","info":"style_info__YprTZ"};